import { createStore } from 'vuex'

export default createStore({
  state: {
    doubleMonit: false
  },
  mutations: {
    SET_DOUBLE_MONIT(state, payload) {
      state.doubleMonit = payload;
    }
  },
  actions: {

  },
  getters: {
    GET_DOUBLE_MONIT(state) {
      return state.doubleMonit;
    }
  },
  modules: {

  }
})
